import authLogoLight from "@/assets/auth-logo-light.png";
import authLogoDark from "@/assets/auth-logo-dark.png";
import { useTheme } from "@/components/ThemeProvider";

export const Integrations = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="flex flex-col items-center justify-center mb-16">
          <h2 className="text-3xl md:text-4xl font-medium text-center text-foreground max-w-4xl">
            One Platform for Everyone in Your Learning World
          </h2>
          <p className="text-muted-foreground mt-4 text-center max-w-2xl">
            Whether you're a student cramming for finals, a teacher building lesson plans, or a parent tracking progress —  Shattara works for you.
          </p>
        </div>

        {/* Integration Hub */}
        <div className="relative max-w-7xl mx-auto">
          {/* SVG Lines */}
          <svg
            className="absolute inset-0 w-full h-full pointer-events-none"
            viewBox="0 0 1400 800"
            preserveAspectRatio="xMidYMid meet">

            <path
              d="M 60,80 Q 300,20 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              strokeDasharray="1000"
              className="animate-flow-line"
              style={{ opacity: 0.4 }} />

            <path
              d="M 60,80 Q 300,20 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              className="animate-pulse-opacity" />

            <path
              d="M 60,720 Q 300,650 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              strokeDasharray="1000"
              className="animate-flow-line"
              style={{ opacity: 0.4 }} />

            <path
              d="M 60,720 Q 300,650 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              className="animate-pulse-opacity" />

            <path
              d="M 1340,80 Q 1100,20 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              strokeDasharray="1000"
              className="animate-flow-line"
              style={{ opacity: 0.4 }} />

            <path
              d="M 1340,80 Q 1100,20 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              className="animate-pulse-opacity" />

            <path
              d="M 1340,720 Q 1100,650 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              strokeDasharray="1000"
              className="animate-flow-line"
              style={{ opacity: 0.4 }} />

            <path
              d="M 1340,720 Q 1100,650 700,400"
              stroke="hsl(var(--primary))"
              strokeWidth="2"
              strokeLinecap="round"
              fill="none"
              className="animate-pulse-opacity" />

          </svg>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-64 relative">

            {/* Top Left Node */}
            <div className="flex justify-center md:justify-end md:pr-32">
              <div className="bg-card border-2 border-border rounded-2xl p-6 flex items-center justify-center w-full max-w-xs text-center">
                <h3 className="text-lg font-semibold text-foreground">High School Students — Ace Your Exams</h3>
              </div>
            </div>

            {/* Top Right Node */}
            <div className="flex justify-center md:justify-start md:pl-32">
              <div className="bg-card border-2 border-border rounded-2xl p-6 flex items-center justify-center w-full max-w-xs text-center">
                <h3 className="text-lg font-semibold text-foreground">University Students — Master Any Subject</h3>
              </div>
            </div>

            {/* Center Node */}
            <div className="md:col-span-2 flex justify-center items-center md:absolute md:top-1/2 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 z-10">
            <div className="flex items-center justify-center p-6 bg-card border-2 border-border rounded-full">
              <img
                  src={isDark ? authLogoDark : authLogoLight}
                  alt="Shattara AI"
                  className="h-24 md:h-32 w-auto" />

            </div>
            </div>

            {/* Bottom Left Node */}
            <div className="flex justify-center md:justify-end md:pr-32">
              <div className="bg-card border-2 border-border rounded-2xl p-6 flex items-center justify-center w-full max-w-xs text-center">
                <h3 className="text-lg font-semibold text-foreground">Educators & Tutors — Engage Every Student</h3>
              </div>
            </div>

            {/* Bottom Right Node */}
            <div className="flex justify-center md:justify-start md:pl-32">
              <div className="bg-card border-2 border-border rounded-2xl p-6 flex items-center justify-center w-full max-w-xs text-center">
                <h3 className="text-lg font-semibold text-foreground">Lifelong Learners — Never Stop Growing</h3>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>);

};